import React from "react";
import { aux, colors } from "../../../theme";
import logoBlack from "../../../assets/logo_black.svg";
import { BellIcon } from "../../common/Svg";
import Boop from "../../common/Boop";
import HeaderDropdown from "./HeaderDropdown";

const HeaderMobile = () => {
  return (
    <div className="flex-col">
      <div
        className="flex w-full bg-white"
        style={{ height: aux.headerHeight }}
      >
        <nav
          id="navigation"
          className="flex justify-between items-center w-full px-4"
        >
          <div className="">
            <button className="outline-0-important" type="button">
              <img alt="logo" src={logoBlack} style={{ height: "29px" }} />
            </button>
          </div>
          <ul className="links">
            <HeaderDropdown className="mr-3" />
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default HeaderMobile;
